<template>
  <div class="w-full grid grid-cols-1 gap-y-8 lg:grid-cols-4 p-6 border-x pb-16">
    <div class="grid gap-x-4 flex justify-center lg:justify-start">
      <img
        v-if="config.body?.reviews_logo_url"
        class="h-[5rem] py-4 mx-auto object-contain"
        :src="config.body?.reviews_logo_url"
        alt="Logo"
      >
      <img
        v-else-if="isPreview()"
        class="h-[5rem] py-4 mx-auto object-contain"
        src="https://placehold.co/160x50"
        alt="Logo"
      >

      <p>
        {{ __('label_based_on') }} <span class="underline font-bold">{{ config.body?.review_count }} {{ __('label_reviews') }}</span>
      </p>

      <TrustPilotStars
        class="h-16 w-48"
        :stars="reviewStars"
      />
    </div>

    <div
      v-for="(review, key) in config.body?.reviews"
      :key="key"
    >
      <Review :review="review" />
    </div>
  </div>
</template>

<script setup>
import Review from '@timon/js/Templates/LANDER-001/Components/Review.vue';
import {ref} from 'vue';
import TrustPilotStars from '@timon/js/Components/TrustPilotStars.vue';
import {isPreview} from '@timon/js/Mixins/helpers';

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },
});

const reviewStars = ref(parseInt(props.config.body?.reviews_stars));
</script>
